<template>
  <div class="container"> <el-image  class="brand-logos-img" src="https://website.obs.icheer.cn/icheer-web/images/logo/icheer-brand-footer-1.png" /></div>
</template>
<script>
export default {
  name: 'ImageTextLine',
  props: ['imgUrl', 'text1', 'text2'],
  data () {
    return {
      icheerLogos: ['艾奇', 'icheer', '万品通', '易合采', 'ODS', '易撮撮', '万巧生', '亮品汇', '万品红', '亮品秀']
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 60px;
  margin-top: 20px;
}
.brand-logos-img{
 width: 100%;
}
</style>
